const ExpertReviewsLogo = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 200 50"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    data-testid="expertReviewsLogo"
    style={{
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
    }}
  >
    <rect
      id="Artboard1"
      x="0"
      y="0"
      width="200"
      height="50"
      style={{
        fill: 'none',
      }}
    />
    <clipPath id="_clip1">
      <rect id="Artboard11" x="0" y="0" width="200" height="50" />
    </clipPath>
    <g clipPath="url(#_clip1)">
      <g transform="matrix(0.809995,0,0,0.809995,-6.81854,-0.908005)">
        <path
          d="M24.774,35.638C24.577,30.621 21.929,28.29 17.9,28.29C13.91,28.29 11.066,31.134 10.67,35.638L24.774,35.638ZM8.418,37.376L8.418,37.06C8.418,30.818 12.37,26.512 17.9,26.512C22.877,26.512 26.947,29.751 26.947,36.586L26.947,37.336L10.591,37.336C10.67,42.867 13.318,46.027 18.216,46.027C21.653,46.027 23.984,44.605 24.695,41.722L26.789,41.722C25.919,45.672 22.641,47.805 18.216,47.805C12.251,47.805 8.418,43.578 8.418,37.376Z"
          style={{
            fill: 'rgb(35,31,32)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.809995,0,0,0.809995,-6.81854,-0.908005)">
        <path
          d="M35.437,36.823L28.248,26.828L30.736,26.828L36.702,35.243L42.587,26.828L44.918,26.828L37.847,36.665L45.668,47.489L43.18,47.489L36.623,38.245L30.064,47.489L27.773,47.489L35.437,36.823Z"
          style={{
            fill: 'rgb(35,31,32)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.809995,0,0,0.809995,-6.81854,-0.908005)">
        <path
          d="M65.735,37.336L65.735,37.02C65.735,31.332 62.377,28.29 58.426,28.29C54.397,28.29 50.723,31.332 50.723,37.02L50.723,37.336C50.723,42.986 54.16,46.027 58.466,46.027C62.811,46.027 65.735,42.867 65.735,37.336ZM48.668,26.828L50.762,26.828L50.762,31.648C51.948,28.961 54.99,26.512 58.624,26.512C63.838,26.512 67.908,30.502 67.908,36.941L67.908,37.257C67.908,43.736 63.958,47.805 58.624,47.805C54.515,47.805 51.869,45.316 50.762,42.788L50.762,54.679L48.668,54.679L48.668,26.828Z"
          style={{
            fill: 'rgb(35,31,32)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.809995,0,0,0.809995,-6.81854,-0.908005)">
        <path
          d="M86.274,35.638C86.077,30.621 83.429,28.29 79.4,28.29C75.41,28.29 72.566,31.134 72.17,35.638L86.274,35.638ZM69.918,37.376L69.918,37.06C69.918,30.818 73.87,26.512 79.4,26.512C84.377,26.512 88.447,29.751 88.447,36.586L88.447,37.336L72.091,37.336C72.17,42.867 74.818,46.027 79.716,46.027C83.153,46.027 85.484,44.605 86.195,41.722L88.289,41.722C87.419,45.672 84.141,47.805 79.716,47.805C73.751,47.805 69.918,43.578 69.918,37.376Z"
          style={{
            fill: 'rgb(35,31,32)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.809995,0,0,0.809995,-6.81854,-0.908005)">
        <path
          d="M91.96,26.828L94.053,26.828L94.053,31.174C95.199,28.645 97.253,26.67 101.046,26.552L101.046,28.527C97.056,28.685 94.053,30.541 94.053,36.033L94.053,47.489L91.96,47.489L91.96,26.828Z"
          style={{
            fill: 'rgb(35,31,32)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.809995,0,0,0.809995,-6.81854,-0.908005)">
        <path
          d="M105.312,42.512L105.312,28.606L102.27,28.606L102.27,26.828L105.312,26.828L105.312,22.127L107.405,22.127L107.405,26.828L112.817,26.828L112.817,28.606L107.405,28.606L107.405,42.353C107.405,44.842 108.591,45.988 110.487,45.988C111.554,45.988 112.383,45.79 113.094,45.554L113.094,47.331C112.423,47.568 111.633,47.766 110.368,47.766C107.09,47.766 105.312,45.83 105.312,42.512Z"
          style={{
            fill: 'rgb(35,31,32)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.809995,0,0,0.809995,-6.81854,-0.908005)">
        <path
          d="M115.344,26.828L122.415,26.828L122.415,30.936C123.719,27.855 125.892,26.512 129.091,26.552L129.091,33.149C124.785,33.03 122.415,34.373 122.415,37.692L122.415,47.489L115.344,47.489L115.344,26.828Z"
          style={{
            fill: 'rgb(35,31,32)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.809995,0,0,0.809995,-6.81854,-0.908005)">
        <path
          d="M144.377,34.808C144.259,32.319 143.034,30.936 140.743,30.936C138.609,30.936 137.147,32.319 136.792,34.808L144.377,34.808ZM129.563,37.415L129.563,37.1C129.563,30.462 134.501,26.275 140.743,26.275C146.392,26.275 151.251,29.515 151.251,36.941L151.251,38.798L136.713,38.798C136.911,41.524 138.491,43.104 141.02,43.104C143.35,43.104 144.338,42.038 144.614,40.655L151.251,40.655C150.619,45.316 147.024,47.963 140.782,47.963C134.304,47.963 129.563,44.171 129.563,37.415Z"
          style={{
            fill: 'rgb(35,31,32)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.809995,0,0,0.809995,-6.81854,-0.908005)">
        <path
          d="M150.342,26.828L157.887,26.828L162.193,40.141L166.42,26.828L173.176,26.828L165.63,47.489L157.927,47.489L150.342,26.828Z"
          style={{
            fill: 'rgb(35,31,32)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.809995,0,0,0.809995,-6.81854,-0.908005)">
        <rect
          x="174.356"
          y="26.828"
          width="7.072"
          height="20.661"
          style={{
            fill: 'rgb(35,31,32)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.809995,0,0,0.809995,-6.81854,-0.908005)">
        <path
          d="M198.137,34.808C198.019,32.319 196.794,30.936 194.503,30.936C192.369,30.936 190.907,32.319 190.552,34.808L198.137,34.808ZM183.322,37.415L183.322,37.1C183.322,30.462 188.261,26.275 194.503,26.275C200.151,26.275 205.011,29.515 205.011,36.941L205.011,38.798L190.473,38.798C190.671,41.524 192.251,43.104 194.779,43.104C197.109,43.104 198.098,42.038 198.374,40.655L205.011,40.655C204.379,45.316 200.784,47.963 194.542,47.963C188.063,47.963 183.322,44.171 183.322,37.415Z"
          style={{
            fill: 'rgb(35,31,32)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.809995,0,0,0.809995,-6.81854,-0.908005)">
        <path
          d="M204.337,26.828L211.725,26.828L214.727,39.193L218.203,26.828L223.892,26.828L226.974,39.193L230.331,26.828L237.047,26.828L230.489,47.489L223.734,47.489L220.652,35.954L217.453,47.489L210.579,47.489L204.337,26.828Z"
          style={{
            fill: 'rgb(35,31,32)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.809995,0,0,0.809995,-6.81854,-0.908005)">
        <path
          d="M236.489,40.932L243.008,40.932C243.245,42.433 243.916,43.262 245.931,43.262C247.669,43.262 248.459,42.591 248.459,41.563C248.459,40.576 247.472,40.102 244.627,39.707C239.097,38.996 236.766,37.376 236.766,33.07C236.766,28.487 240.835,26.275 245.615,26.275C250.711,26.275 254.267,28.013 254.74,32.951L248.341,32.951C248.064,31.569 247.313,30.897 245.694,30.897C244.153,30.897 243.363,31.569 243.363,32.517C243.363,33.504 244.312,33.899 246.84,34.216C252.568,34.927 255.333,36.428 255.333,40.853C255.333,45.751 251.699,47.963 245.971,47.963C240.084,47.963 236.647,45.514 236.489,40.932Z"
          style={{
            fill: 'rgb(35,31,32)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.809995,0,0,0.809995,-6.81854,-0.908005)">
        <path
          d="M178.836,9.597L180.461,14.805C180.519,14.987 180.688,15.111 180.881,15.109L186.336,15.045C186.761,15.04 186.938,15.587 186.592,15.833L182.141,18.988C181.984,19.099 181.92,19.299 181.98,19.481L183.728,24.65C183.863,25.053 183.398,25.391 183.058,25.137L178.681,21.878C178.527,21.764 178.316,21.764 178.163,21.878L173.787,25.137C173.445,25.391 172.98,25.053 173.117,24.65L174.863,19.481C174.925,19.299 174.859,19.099 174.703,18.988L170.252,15.833C169.905,15.587 170.083,15.04 170.508,15.045L175.964,15.109C176.155,15.111 176.325,14.987 176.383,14.805L178.008,9.597C178.135,9.19 178.709,9.19 178.836,9.597Z"
          style={{
            fill: 'rgb(235,120,42)',
            fillRule: 'nonzero',
          }}
        />
      </g>
    </g>
  </svg>
);

export default ExpertReviewsLogo;
